<template>
  <div>
      <LoginLogout/>

      <div>
        <img :src="$auth.user.picture">
        <h2>{{ $auth.user.name }}</h2>
      </div>

      <div>
        <pre>{{ JSON.stringify($auth.user, null, 2) }}</pre>
      </div>
  </div>
    
      
  
</template>

<script>
import LoginLogout from '@/components/LoginLogout.vue'

export default {
  name: 'Profile-view',
  components: {
    LoginLogout
  },
  data() {
            return {
            }
  }
}
</script>
